import { Youtube } from "../class/Youtube.js";

export function upravStranku() {
  Lc.f("uprav stranku video navodu");

  Youtube.getVideosFromPlaylist({
    playlistID: "PLyHJCoNDCsI1yNjBUps-sNoFps6Vw_rTv",
    apiKey: "AIzaSyAF9n2fBWrpklSEsiDtexUhy7pXNXcy96I"
  }).then(kod => {
    $(kod).appendTo("main#content");
    Youtube.showYoutubeVideos();
  });
} //export function  upravStranku()
